export default __webpack_public_path__ + "static/IBMPlexSans-BoldItalic-Latin2-f3e69464cbeea7a9ac37467aba407bf3.woff";